import { useCallback } from 'react';

import { UserGroupIcon } from '@heroicons/react/24/outline';
import { AxiosResponse } from 'axios';

import { IListPaging } from '@/types/IList';
import { IOrganisationGroup } from '@/types/IOrganisation';

import SearchableInput, { Item } from '../SearchableInput';

export type Props = {
  fetchData?: (groupIds: number[]) => void;
  listGroups: ({
    search,
    orgID,
  }: {
    search?: string;
    orgID?: number;
  }) => Promise<
    AxiosResponse<{
      data: IOrganisationGroup[];
      paging: IListPaging;
    }>
  >;
};

const GroupFilter: React.FC<Props> = ({ fetchData, listGroups }) => {
  const mapGroupsToItems = useCallback(
    (remoteGroups: IOrganisationGroup[]): Item[] => {
      return remoteGroups.map(({ id, name }) => {
        const title = name === null ? 'No name' : name.trim();

        return {
          id,
          title,
        };
      });
    },
    [],
  );

  const searchItems = async (query: string) => {
    const {
      data: { data: remoteGroups },
    } = await listGroups({ search: query });

    return mapGroupsToItems(remoteGroups);
  };

  return (
    <SearchableInput
      key="group-filter-analytics"
      icon={<UserGroupIcon className="w-4 h-4 mr-2" strokeWidth={2} />}
      title="Groups"
      fetchData={fetchData}
      searchItems={searchItems}
      emptyMessage="No groups available"
    />
  );
};

export default GroupFilter;
